import { createSelector } from 'reselect';

import { RootState } from '../models';

export const selectIsFullscreen = createSelector(
  (state:RootState) => state.context.isNativeFullscreen,
  (state:RootState) => state.context.isUtilityServiceFullscreen,
  (isNativeFullscreen:boolean, isUtilityServiceFullscreen:boolean) => isNativeFullscreen || isUtilityServiceFullscreen
);